import { useMemo, Dispatch, SetStateAction } from 'react';
import { useContractsStore, contractSearchableFields } from '../store';
import { useEntityCollectionInitializer } from 'store/entityCollection';
import { filterBySearchPhrase } from 'components/common/SearchInput/helpers';
import { useEmptyListReason } from 'hooks/table/useEmptyListReason';
import { ContractModel } from 'shared/domain/contract/types/model';

export function useContractsInitializer(): void {
  useEntityCollectionInitializer(useContractsStore.use.actions());
}

export function useContracts(): {
  items: ContractModel[];
  loading: boolean;
  searchPhrase: string;
  setSearchPhrase: Dispatch<SetStateAction<string>>;
  emptyListReason: ReturnType<typeof useEmptyListReason>;
} {
  const data = useContractsStore.use.data();
  const search = useContractsStore.use.search();
  const actions = useContractsStore.use.actions();

  const filtered: ContractModel[] = useMemo(() => {
    return filterBySearchPhrase(
      data.items,
      search.phrase,
      contractSearchableFields
    );
  }, [search.phrase, data.items]);

  const emptyListReason = useEmptyListReason(
    search.phrase,
    filtered.length,
    0,
    data.loading
  );

  return {
    items: filtered,
    loading: data.loading,
    searchPhrase: search.phrase,
    setSearchPhrase: actions.setSearchPhrase,
    emptyListReason,
  };
}
